__turbopack_context__.v({
  "media-video": "video-player-module-scss-module__QgwN6q__media-video",
  "mobile-media-video": "video-player-module-scss-module__QgwN6q__mobile-media-video",
  "play-button": "video-player-module-scss-module__QgwN6q__play-button",
  "video": "video-player-module-scss-module__QgwN6q__video",
  "video-container": "video-player-module-scss-module__QgwN6q__video-container",
});
